import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { sendFeedback, getProjectRevisions } from 'project/ducks/revisions';
import { getProjectEntries, getProjectEntriesState, dismissFeedback } from 'project/ducks/entries';

import PositiveFeedback from 'project/components/entries/positive_feedback';

export const FORM_NAME = 'REVISION_FEEDBACK_NEGATIVE';

export function validate(values) {
  const errors = {};

  if (!values.feedback) {
    errors.feedback = 'Please enter some feedback';
  }

  if (values.feedback && !values.feedback.trim()) {
    errors.feedback = 'Please enter some feedback';
  }

  return errors;
}

export function mapStateToProps(state) {
  const { scoredRevision } = getProjectEntriesState(state);
  const { entry } = getProjectRevisions(state)[scoredRevision];
  const { author_username } = getProjectEntries(state)[entry];

  return { author_username };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: sendFeedback,
    onHide: dismissFeedback,
  }, dispatch);
}

const PositiveFeedbackForm = reduxForm({
  form: FORM_NAME,
  validate,
})(PositiveFeedback);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PositiveFeedbackForm));



// WEBPACK FOOTER //
// ./project/containers/entries/positive_feedback.js